__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/1e46c21/_next/";